import { API } from "../../config";

export const createRates = (token, inputType, payload, courierType) => {
  let data = {
    price: payload.basePrice,
    price_per_kg: payload.weightExtraPrice,
    price_per_vol: payload.volumeExtraPrice,
  };

  if (courierType === "instant") {
    data = {
      ...data,
      price_per_km: payload.distanceExtraPrice,
      origin_lat_coordinate: payload.originLat,
      origin_lng_coordinate: payload.originLng,
      destination_lat_coordinate: payload.destinationLat,
      destination_lng_coordinate: payload.destinationLng,
    };
  } else {
    if (inputType === "kodepos") {
      data = {
        ...data,
        origin_postal_code: payload.origin,
        destination_postal_code: payload.destination,
      };
    } else if (inputType === "kecamatan") {
      data = {
        ...data,
        origin_district_id: payload.origin,
        destination_district_id: payload.destination,
      };
    } else if (inputType === "kota") {
      data = {
        ...data,
        origin_city_id: payload.origin,
        destination_city_id: payload.destination,
      };
    }
  }

  return fetch(`${API}/v1/open_courier/rates`, {
    mode: "cors",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const createImportRates = (token, payload, courierType) => {
  let data = {
    price: payload["Base Price"],
    price_per_kg: payload["Price per Kg"],
    price_per_vol: payload["Price per Volume"],
  };
  if (courierType === "instant") {
    data = {
      ...data,
      price_per_km: payload["Price per Km"],
      origin_lat_coordinate: payload["Origin Latitude"],
      origin_lng_coordinate: payload["Origin Longitude"],
      destination_lat_coordinate: payload["Destination Latitude"],
      destination_lng_coordinate: payload["Destination Longitude"],
    };
  } else {
    if (payload["Origin Postal Code"] && payload["Destination Postal Code"]) {
      data = {
        ...data,
        origin_postal_code: payload["Origin Postal Code"],
        destination_postal_code: payload["Destination Postal Code"],
      };
    } else if (payload["Origin District Id"] && payload["Destination District Id"]) {
      data = {
        ...data,
        origin_district_id: payload["Origin District Id"],
        destination_district_id: payload["Destination District Id"],
      };
    } else {
      data = {
        ...data,
        origin_city_id: payload["Origin City Id"],
        destination_city_id: payload["Destination City Id"],
      };
    }
  }
  return fetch(`${API}/v1/open_courier/rates`, {
    mode: "cors",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getRates = (token, page = 1, limit = 10) => {
  return fetch(`${API}/v1/open_courier/rates?page=${page}&limit=${limit}`, {
    mode: "cors",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const updateRates = (token, initialValue, newValue) => {
  let data = {
    price: newValue.basePrice,
    price_per_kg: newValue.weightExtraPrice,
    price_per_vol: newValue.volumeExtraPrice,
  };
  if (initialValue.courier_type === "instant")
    data = { ...data, price_per_km: newValue.distanceExtraPrice };

  return fetch(`${API}/v1/open_courier/rates/${initialValue.rate_id}`, {
    mode: "cors",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const deleteRates = (token, data) => {
  return fetch(`${API}/v1/open_courier/rates/${data.rate_id}`, {
    mode: "cors",
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};
